import { EventPermissions } from '@thro-types/access-handler';

import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';

import { EventDetailPage } from './EventDetailPage';
import { EventList } from './EventList';

export const Events = ({ currentUser, userPermission }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute notAnonymous user={currentUser}>
            <EventList />
          </PrivateRoute>
        }
      />
      <Route
        path=":id"
        element={
          <PrivateRoute
            notAnonymous
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={EventPermissions.EVENTS_EVENT_READ}
          >
            <EventDetailPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
